"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _coreSimpleGrid = _interopRequireDefault(require("@vfuk/core-simple-grid"));
var _coreHeading = _interopRequireDefault(require("@vfuk/core-heading"));
var _coreLink = _interopRequireDefault(require("@vfuk/core-link"));
var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));
var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));
var _coreBaseProps = require("@vfuk/core-base-props");
var Styled = _interopRequireWildcard(require("./styles/DesktopLinkList.style"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DesktopLinkList = function DesktopLinkList(_ref) {
  var linkGroups = _ref.linkGroups,
    onInteractionClick = _ref.onInteractionClick,
    inverse = _ref.inverse,
    dataSelectorPrefix = _ref.dataSelectorPrefix;
  var getNumberOfColumns = function getNumberOfColumns() {
    var groupsLength = linkGroups.groups.length;
    if (groupsLength === 3 || groupsLength === 5 || groupsLength === 6) {
      return 3;
    }
    if (groupsLength === 4 || groupsLength === 7 || groupsLength === 8) {
      return 4;
    }
    return 2;
  };
  return /*#__PURE__*/_react["default"].createElement(_coreSimpleGrid["default"], {
    columns: {
      lg: getNumberOfColumns()
    },
    spacing: 4,
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix)
  }, linkGroups.groups.map(function (group, index) {
    return /*#__PURE__*/_react["default"].createElement(Styled.DesktopLinkListWrapper, {
      key: (0, _uuid.v4)()
    }, /*#__PURE__*/_react["default"].createElement(_coreHeading["default"], {
      size: 1,
      weight: 3,
      inverse: inverse,
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "group-heading-".concat(index))
    }, group.headingText), /*#__PURE__*/_react["default"].createElement(_coreListGroup["default"], {
      dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "group-list-".concat(index))
    }, group.links.map(function (link) {
      return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
        key: link.id,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "group-list-item-".concat(index))
      }, /*#__PURE__*/_react["default"].createElement(_coreLink["default"], _extends({
        inverse: inverse,
        srText: link.srText,
        href: link.href,
        customRouterProps: link.customRouterProps,
        onClick: onInteractionClick,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix, "group-list-item-link-".concat(index))
      }, link.dataAttributes), link.text));
    })));
  }));
};
DesktopLinkList.displayName = "DesktopLinkList";
var _default = DesktopLinkList;
exports["default"] = _default;